import {
  GET_WORKGROUP,
  GET_WORKGROUP_SUCCESS,
  GET_WORKGROUP_FAIL,
  DELETE_WORKGROUP,
  DELETE_WORKGROUP_SUCCESS,
  DELETE_WORKGROUP_FAIL,
  UPDATE_WORKGROUP,
  UPDATE_WORKGROUP_SUCCESS,
  UPDATE_WORKGROUP_FAIL,
  ADD_NEW_WORKGROUP,
  ADD_WORKGROUP_SUCCESS,
  ADD_WORKGROUP_FAIL,
  WORKGROUP_LOADING,
  WORKGROUP_RESET,
} from "./actionType";

export const resetWorkGroupState = (actionType) => ({
  type: WORKGROUP_RESET,
  payload: { actionType },
});

export const getWorkGroupSuccess = (actionType, data) => ({
  type: GET_WORKGROUP_SUCCESS,
  payload: { actionType, data },
});

export const getWorkGroupFail = (actionType, error) => ({
  type: GET_WORKGROUP_FAIL,
  payload: { actionType, error },
});

export const getWorkGroup = data => ({
  type: GET_WORKGROUP,
  payload: data,
});

export const getWorkGroupLoading = () => ({
  type: WORKGROUP_LOADING
});

export const deleteWorkGroup = data => ({
  type: DELETE_WORKGROUP,
  payload: data,
});

export const deleteWorkGroupSuccess = data => ({
  type: DELETE_WORKGROUP_SUCCESS,
  payload: data,
});

export const deleteWorkGroupFail = error => ({
  type: DELETE_WORKGROUP_FAIL,
  payload: error,
});

export const updateWorkGroup = data => ({
  type: UPDATE_WORKGROUP,
  payload: data,
});

export const updateWorkGroupFail = error => ({
  type: UPDATE_WORKGROUP_FAIL,
  payload: error,
});

export const updateWorkGroupSuccess = data => ({
  type: UPDATE_WORKGROUP_SUCCESS,
  payload: data,
});

export const addNewWorkGroup = data => ({
  type: ADD_NEW_WORKGROUP,
  payload: data,
});

export const addWorkGroupSuccess = data => ({
  type: ADD_WORKGROUP_SUCCESS,
  payload: data,
});

export const addWorkGroupFail = error => ({
  type: ADD_WORKGROUP_FAIL,
  payload: error,
});